import isElectron from "./electronChecker";
import Bowser from "bowser";
const browser = Bowser.getParser(window.navigator.userAgent);

const isValidBrowser = browser.satisfies({
  chrome: ">=78" // will match any 78.* sub-version
});
const isChromeOS = browser.parsedResult.os.name === "Chrome OS";

const isWeb = !isElectron && !isChromeOS;

export { isElectron, isChromeOS, isWeb, isValidBrowser };
